/**
 *
 * Duration
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Input from 'components/tags/Input/index.jsx';
import FormControlWrapper from 'components/interaction/Form4/FormControlWrapper.jsx';
import cx from 'utils/cx.js';
import messages from './messages.js';

const Wrapper = styled.div`
    input.form-control {
      max-width: 5rem;
    }
`;

function Duration({ unit = messages.minutes, onChange, className, min = 1, step = 1, ...props }) {
  const onNumberChange = (ev) => onChange(Number(ev.target.value || '0'));
  return (
    <FormControlWrapper className={cx('d-inline-block w-auto', className)} border={1}>
      <Wrapper className="inline-block text-nowrap">
        <Input min={min} step={step} unit={unit} {...props} onChange={onNumberChange} type="number" className="form-control d-inline-block text-center me-3" />
        <FormattedMessage {...unit} />
      </Wrapper>
    </FormControlWrapper>
  );
}

Duration.propTypes = {
  min: PropTypes.number,
  step: PropTypes.number,
  unit: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

export default Duration;
